import { render, staticRenderFns } from "./EventInfoSiteTemplate.vue?vue&type=template&id=04745822&"
import script from "./EventInfoSiteTemplate.vue?vue&type=script&lang=ts&"
export * from "./EventInfoSiteTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./EventInfoSiteTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports